import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';
//import moment from 'moment';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { SimpleTable } from '~/components';

//import { Input, Checkbox } from '~/components/Form';

import { t } from '~/helpers';
import api from '~/services/api';

import { FormWrapper } from './styles';

import * as S from './styles';

export default function MyForm({ data, reference, close }) {
  // const [posto, setPosto] = useState(0);
  // const [veiculo, setVeiculo] = useState(null);
  // const [custo, setCusto] = useState(null);
  // const [motorista, setMotorista] = useState(null);
  // const [totalizador, setTotalizador] = useState(0);
  // const [empresaVeiculo, setEmpresaveiculo] = useState(null);

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        movi_totalizador_veiculo_novo: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(0),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
      };

      await api.put('alterartotalizadorabastecimento', objSend);
      toast.success(t('s.geral.sucessoalteracao'));

      await close();
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }

      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    reference.current.setData(data);
  }, []);

  return (
    <>

      <S.Wrapper>

        <FormWrapper ref={reference} initialData={data} onSubmit={handleSubmit}>

          <SimpleTable
            style={{width: '100px'}} 
            
            url="impedimentoitemdetalhes"
            cells={[
              {
                id: 'imab_codigo',
                label: 'Cód Impedimento',
              },
              {
                id: 'iiab_codigo',
                label: '--------------',
              },
              {
                id: 'iiab_descricao',
                label: 'Descrição',
              }

            ]}
            unique={['imab_codigo', 'iiab_codigo']}
            form={MyForm}
            onCreate={false}
            onUpdate={false}
            onDelete={false}
            title={'Lista de Impedimentos'}
            restProps={''}
            query={{
              wherefield: ['imab_codigo'],
              valuewherefield: [data.imab_codigo],
              typewherefield: ['EQUALS'],
            }}
          />
        </FormWrapper>
      </S.Wrapper>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
